import { ReactNode } from 'react'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers'
import moment from 'moment'

interface IDateProviderProps {
  children: ReactNode
}

export const DateProvider = ({ children }: IDateProviderProps) => {
  // const { data: me, isLoading, isSuccess } = useMe()
  // const { data: user, isLoading: isUserLoading } = useUser()

  // useEffect(() => {
  //   if (isSuccess && me) {
  //     const d = new Date(me.created_at as string)
  //     window.Intercom('boot', {
  //       api_base: 'https://api-iam.intercom.io',
  //       app_id: 'pcg5gtxa',
  //       name: me?.name || me.email,
  //       email: me?.email,
  //       created_at: d.getTime() / 1000,
  //     })
  //   } else {
  //     window.Intercom('boot', {
  //       app_id: 'pcg5gtxa',
  //     })
  //   }
  // }, [isSuccess, me, isLoading, user, isUserLoading])

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment.utc}>
      {children}
    </LocalizationProvider>
  )
}
